// extracted by mini-css-extract-plugin
export default {"paperRoot":"src-client-components-Box-styles-___default__paperRoot___z37KW"};